export const loader = `
  <div id="splash">
    <svg class="splash-pulse" width="248" height="64" viewBox="0 0 248 64" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_826_23263)">
        <path
          d="M31.9865 60.5082C40.178 60.5082 46.5878 58.4815 51.2159 54.4282C55.844 50.3749 58.1611 44.7278 58.1674 37.487V4.78117C58.1843 4.67016 58.1753 4.55671 58.141 4.4498C58.1067 4.34289 58.048 4.24545 57.9697 4.16513C57.8913 4.08481 57.7955 4.02382 57.6896 3.98699C57.5837 3.95017 57.4707 3.93851 57.3595 3.95293H46.7538C46.2183 3.95293 45.9553 4.22587 45.9553 4.78117V35.84C46.0253 37.4912 45.7563 39.1392 45.1649 40.682C44.5735 42.2249 43.6723 43.6297 42.5171 44.8094C40.225 47.0808 36.5927 48.2165 31.6201 48.2165H30.6807C25.3638 48.2165 21.6344 47.1529 19.4926 45.0259C17.3507 42.8988 16.2767 39.8337 16.2704 35.8306V32.1224C16.2704 31.5671 16.0074 31.2941 15.472 31.2941H4.57498C4.46381 31.2797 4.35084 31.2914 4.24495 31.3282C4.13906 31.365 4.04315 31.426 3.96481 31.5063C3.88646 31.5866 3.82782 31.6841 3.79351 31.791C3.7592 31.8979 3.75016 32.0114 3.7671 32.1224V37.5247C3.7671 44.8345 6.07174 50.4816 10.681 54.4659C15.2903 58.4502 21.8097 60.4518 30.2392 60.4706L31.9865 60.5082Z"
          fill="#F0F0F1" />
        <path
          d="M137.837 28.0659C138.082 23.4541 139.716 19.8965 142.741 17.3929C145.996 14.8048 150.068 13.4693 154.22 13.6282C161.817 13.6282 165.888 15.9592 166.432 20.6212C166.526 21.2706 166.818 21.5623 167.306 21.5623H179.669C180.251 21.5623 180.523 21.2423 180.476 20.6212C179.149 14.6541 176.478 10.1961 172.463 7.24705C168.449 4.29803 162.368 2.82039 154.22 2.81412C145.584 2.81412 138.695 5.32392 133.554 10.3435C128.412 15.3631 125.829 22.9114 125.804 32.9882C125.804 42.1553 127.996 49.029 132.379 53.6094C136.763 58.1898 143.724 60.48 153.262 60.48C161.454 60.4361 167.986 58.7576 172.858 55.4447C175.183 53.9756 177.093 51.9344 178.407 49.5158C179.721 47.0972 180.394 44.3817 180.364 41.6282C180.364 35.8243 178.341 31.407 174.295 28.3764C170.25 25.3459 164.19 23.8023 156.118 23.7459C147.638 23.7459 141.545 25.1733 137.837 28.0282V28.0659ZM143.211 47.52C140.749 46.1647 139.519 44.2604 139.519 41.8071C139.519 36.6494 144.369 34.0706 154.07 34.0706C163.464 34.0706 168.145 36.5804 168.114 41.6C168.114 46.8015 163.433 49.4557 154.07 49.5623C149.298 49.5623 145.678 48.8879 143.211 47.5388V47.52Z"
          fill="#F0F0F1" />
        <path
          d="M120.835 59.4541C120.945 59.4686 121.056 59.4572 121.161 59.4208C121.266 59.3845 121.361 59.3242 121.438 59.2448C121.516 59.1653 121.574 59.0689 121.607 58.9631C121.641 58.8573 121.65 58.7451 121.633 58.6353V49.2235C121.65 49.1134 121.641 49.0009 121.607 48.8948C121.573 48.7887 121.515 48.6918 121.438 48.6117C121.361 48.5316 121.266 48.4704 121.162 48.4328C121.057 48.3953 120.945 48.3825 120.835 48.3953H79.1537V36.847H112.972C113.082 36.8611 113.194 36.8496 113.299 36.8133C113.404 36.7769 113.5 36.7168 113.578 36.6376C113.656 36.5584 113.715 36.4623 113.75 36.3566C113.785 36.2509 113.795 36.1385 113.78 36.0282V26.7106C113.797 26.5996 113.788 26.4861 113.753 26.3792C113.719 26.2723 113.66 26.1748 113.582 26.0945C113.504 26.0142 113.408 25.9532 113.302 25.9164C113.196 25.8796 113.083 25.8679 112.972 25.8824H79.1537V14.9176H120.684C120.795 14.932 120.908 14.9204 121.014 14.8836C121.12 14.8467 121.216 14.7858 121.294 14.7055C121.373 14.6251 121.431 14.5277 121.466 14.4208C121.5 14.3138 121.509 14.2004 121.492 14.0894V4.78117C121.509 4.67016 121.5 4.55671 121.466 4.4498C121.431 4.34289 121.373 4.24545 121.294 4.16513C121.216 4.08481 121.12 4.02382 121.014 3.98699C120.908 3.95017 120.795 3.93851 120.684 3.95293H67.74C67.2046 3.95293 66.9415 4.22587 66.9415 4.78117V58.6353C66.9245 58.7451 66.9333 58.8573 66.9671 58.9631C67.0009 59.0689 67.0589 59.1653 67.1364 59.2448C67.2139 59.3242 67.3088 59.3845 67.4135 59.4208C67.5183 59.4572 67.6301 59.4686 67.74 59.4541H120.835Z"
          fill="#F0F0F1" />
        <path
          d="M215.92 60.5835C234.244 60.5835 243.41 54.6509 243.416 42.7858V42.7106C243.447 40.2239 242.814 37.774 241.584 35.6141C240.509 33.6229 238.85 32.01 236.831 30.9929C238.702 30.0168 240.213 28.4669 241.142 26.5694C242.244 24.4497 242.799 22.0881 242.758 19.6988V19.6235C242.758 8.40467 233.762 2.79526 215.769 2.79526H214.746C196.903 2.79526 187.982 8.44232 187.982 19.7364V19.8117C187.948 22.1718 188.49 24.5044 189.56 26.607C190.472 28.4972 191.972 30.0396 193.835 31.0023C191.798 32.0351 190.136 33.6807 189.081 35.7082C187.862 37.8727 187.231 40.3195 187.249 42.8047V42.88C187.249 54.6949 196.415 60.6023 214.746 60.6023L215.92 60.5835ZM203.999 24.9035C201.707 23.9059 200.561 22.3247 200.561 20.1976V20.1223C200.561 16.0627 205.486 14.0329 215.337 14.0329C225.188 14.0329 230.136 16.1129 230.18 20.2729V20.3482C230.18 22.4 229.015 23.9153 226.704 24.8847C224.393 25.8541 220.598 26.3811 215.337 26.4282C210.077 26.4752 206.291 25.9294 203.999 24.9223V24.9035ZM199.828 42.7106V42.6353C199.828 40.5835 201.04 39.087 203.454 38.1647C205.868 37.2423 209.804 36.7718 215.262 36.7718C220.72 36.7718 224.656 37.2517 227.108 38.2023C229.56 39.1529 230.866 40.6776 230.866 42.7858V42.8611C230.866 44.9631 229.647 46.5317 227.211 47.567C224.775 48.6023 220.817 49.1325 215.337 49.1576C204.998 49.1576 199.828 47.0055 199.828 42.7012V42.7106Z"
          fill="#F0F0F1" />
      </g>
      <defs>
        <clipPath id="clip0_826_23263">
          <rect width="239.658" height="57.76" fill="white" transform="translate(3.75781 2.82352)" />
        </clipPath>
      </defs>
    </svg>
    <svg 
      viewBox="0 0 38 38"
      xmlns="http://www.w3.org/2000/svg"
      style="stroke: #00C087; width: 40px; height: 40px">
      <g fill="none" fillRule="evenodd">
        <g transform="translate(1 1)" strokeWidth="4">
          <path d="M36 18c0-9.94-8.06-18-18-18">
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 18 18"
              to="360 18 18"
              dur="1s"
              repeatCount="indefinite"
            />
          </path>
        </g>
      </g>
    </svg>
  </div>
`;

export const noscript = (msg: string) => `<noscript id="noscript">
  <svg width="130" height="35" viewBox="0 0 130 35" xmlns="http://www.w3.org/2000/svg"><path d="M76.786 9.119h-9.154L62.46 33.492h9.876L75.148 20.4c.576-2.534 1.846-4.647 4.862-4.647 1.697 0 3.327.775 2.764 3.4l-3.05 14.34h9.8l2.94-13.764c.45-2.1.688-3.567.688-4.647 0-4.788-4.341-6.573-8.698-6.573-2.485 0-5.565.997-7.668 3.08v-2.47zM7.087 0L0 33.491h21.75c1.704 0 3.562-.34 5.3-1.032 4.636-1.847 8.027-7.587 5.848-12.461-.806-1.8-1.969-2.856-3.463-3.723 2.953-1.097 5.173-3.577 5.53-7.02C35.475 4.364 31.519 0 26.23 0H7.087zm6.196 19.268h6.102c2.203 0 4.23.381 4.071 2.863-.165 2.59-2.586 3.38-4.454 3.38h-7.03l1.31-6.243zm2.466-11.694h6.316c1.867 0 3.553.548 3.33 2.587-.25 2.273-2.485 2.863-3.918 2.863H14.62l1.13-5.45zm19.19 15.141c0 8.553 5.779 11.41 12.9 11.41 11.903 0 15.588-8.686 15.588-14.93 0-7.37-4.98-10.656-12.55-10.656-10.558 0-15.937 6.765-15.937 14.176zm9.966-1.552c.6-3.524 2.638-6.33 5.403-6.33 2.845 0 3.832 2.908 3.233 6.433-.6 3.524-2.632 6.332-5.403 6.332-2.84 0-3.832-2.908-3.233-6.435zm57.95 4.771c0-1.507 1.501-2.324 3.066-2.58 3.66-.598 5.09-1.4 5.09-1.4-.737 3.977-2.423 5.903-5.137 6.121-1.833.15-3.018-.559-3.018-2.14zm2.906-9.048c.525-1.83 1.891-2.9 3.856-2.94 1.437-.03 2.97.462 2.97 1.919 0 2.47-5.296 2.447-7.968 2.733-7.13.76-12.02 2.388-12.02 8.819 0 4.646 3.783 6.694 8.046 6.694 2.693 0 6.076-.193 8.508-2.337-.102.56.003 1.186.13 1.718h10.338c-.354-.863-.521-2.107-.13-3.957l2.593-12.187c1.707-8.032-6.912-8.823-12.758-8.823-6.082 0-12.322 1.883-13.807 8.361h10.242zm20.414-6.95c2.137 0 3.825-1.656 3.825-3.732 0-2.075-1.688-3.73-3.825-3.73-2.138 0-3.825 1.655-3.825 3.73 0 2.076 1.687 3.731 3.825 3.731zm0-.574c-1.747 0-3.24-1.397-3.24-3.158 0-1.76 1.493-3.155 3.24-3.155 1.746 0 3.24 1.395 3.24 3.155 0 1.761-1.494 3.158-3.24 3.158zm.555-3.023c.741-.02 1.319-.317 1.319-1.12 0-.88-.734-1.081-1.484-1.081h-1.815v4.085h.585V6.34h.701l1.253 1.884h.7L126.73 6.34zm-1.395-.575V4.713h1.111c.452 0 1.017.076 1.017.497 0 .65-.908.554-1.427.554h-.7z" fill="#1C223F" fill-rule="evenodd"/></svg>
  <div class="container">
    ${msg}
  </div>
</noscript>`;

export const legacyBrowserMsg = (
  msg: string
) => `<div id="legacyBrowserMsg" hidden style="position:fixed; z-index:99999999; top: 0; left: 0; right: 0; text-align:center; padding: 20px; background: #c40d3e; color: white;">
  <div style="max-width: 1200px; width:100%; margin: 0 auto;">
    <div style="display:inline-block; width: calc(100% - 70px); margin: 0; padding: 0 10px 15px 0;">
      ${msg}
    </div>
    <svg onclick="setLegacyCookie()" width="36" height="36" viewBox="0 0 36 36" style="display:inline-block; width: 40px; height: 40px; background-size: 16px; padding: 9px;-webkit-transition: background-color .3s cubic-bezier(.25,.46,.45,.94); transition: background-color .3s cubic-bezier(.25,.46,.45,.94); background-repeat: no-repeat; background-position: 50%; border: none; cursor: pointer; background-color: transparent;" xmlns="http://www.w3.org/2000/svg"><path d="M.357 35.643c.248.248.558.373.899.373.34 0 .651-.125.899-.373L18 19.798l15.845 15.845c.248.248.558.373.9.373a1.273 1.273 0 0 0 .9-2.17L19.796 17.999 35.643 2.155A1.273 1.273 0 0 0 33.845.357L18 16.202 2.155.357A1.273 1.273 0 0 0 .357 2.155L16.202 18 .357 33.845a1.273 1.273 0 0 0 0 1.798z" fill="#fff" fill-rule="nonzero"/></svg>
  </div>
</div>`;

export const legacyBrowserLogic = `
  <script>
    function setLegacyCookie() {
      var date = new Date();date.setTime(date.getTime() + 10 * 24 * 60 * 60 * 1000);
      var expires = date.toGMTString();document.cookie = "legacyCookie=true;" + "expires=" + expires + ";path=/"; 
      document.getElementById("legacyBrowserMsg").hidden = true;
    }
    function legacyCookieNotExists() { 
      const nameEQ = "legacyCookie="; 
      const ca = document.cookie.split(";"); 
      for (let i = 0; i < ca.length; i++) { 
        let c = ca[i]; while (c.charAt(0) === " ") 
        c = c.substring(1, c.length); 
        if (c.indexOf(nameEQ) === 0) 
          return false; 
      } 
        return true; 
    }

    if(legacyCookieNotExists()){
      document.getElementById("legacyBrowserMsg").removeAttribute("hidden");
    }

  </script>`;

export const getGoogleTagManagerScript = (googleTagManagerId: string) => {
  return googleTagManagerId !== ''
    ? `
  <script>
    dataLayer = [];
  </script>
  <!-- Google Tag Manager -->
  <script data-cookieconsent="ignore">(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${googleTagManagerId}');</script>
  <!-- End Google Tag Manager -->
  `
    : ``;
};

export const getGoogleTagManagerNoScript = (googleTagManagerId: string) => {
  return googleTagManagerId !== ''
    ? `<!-- Google Tag Manager (noscript) -->
  <noscript>
    <iframe src="https://www.googletagmanager.com/ns.html?id=${googleTagManagerId}"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>
  </noscript>
  <!-- End Google Tag Manager (noscript) -->`
    : ``;
};

export const getApplicationInsightsScript = (instrumentationKey: string) => {
  if (!instrumentationKey) {
    return '';
  }

  return `
    var appInsights =
      window.appInsights ||
      (function (config) {
        function t(config) {
          i[config] = function () {
            var t = arguments;
            i.queue.push(function () {
              i[config].apply(i, t);
            });
          };
        }
        var i = { config: config },
          u = document,
          e = window,
          o = 'script',
          s = 'AuthenticatedUserContext',
          h = 'start',
          c = 'stop',
          l = 'Track',
          a = l + 'Event',
          v = l + 'Page',
          r,
          f;
        setTimeout(function () {
          var t = u.createElement(o);
          t.src =
            config.url || 'https://az416426.vo.msecnd.net/scripts/a/ai.0.js';
          u.getElementsByTagName(o)[0].parentNode.appendChild(t);
        });
        try {
          i.cookie = u.cookie;
        } catch (y) { }
        for (
          i.queue = [],
          r = [
            'Event',
            'Exception',
            'Metric',
            'PageView',
            'Trace',
            'Dependency',
          ];
          r.length;

        )
          t('track' + r.pop());
        return (
          t('set' + s),
          t('clear' + s),
          t(h + a),
          t(c + a),
          t(h + v),
          t(c + v),
          t('flush'),
          config.disableExceptionTracking ||
          ((r = 'onerror'),
            t('_' + r),
            (f = e[r]),
            (e[r] = function (config, t, u, e, o) {
              var s = f && f(config, t, u, e, o);
              return s !== !0 && i['_' + r](config, t, u, e, o), s;
            })),
          i
        );
      })({
        instrumentationKey: '${instrumentationKey}',
        sdkExtension: 'a',
      });
    window.appInsights = appInsights;
    appInsights.queue &&
      appInsights.queue.length === 0 &&
      appInsights.trackPageView();
    `;
};

export const getSplashLoaderStyle = () => {
  return `<style>
    .splash-remove {
   
    }

    .splash-pulse {
      
    }

    #noscript,
    #splash {
      position: fixed;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      background: #0E0E10;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
      flex-direction: column;
    }

    #noscript svg,
    #splash svg {
      height: auto;
      width: 50%;
      max-width: 200px;
      margin-bottom: 5%;
      
    }
    #noscript svg {
      height: 60px;
      margin-bottom: 30px;
    }

    #noscript .container {
      width: 100%;
      padding: 0 15px 30px;
      box-sizing: border-box;
      text-align: center;
      margin-bottom: 5%;
    }

    #noscript {
      z-index: 99991;
      flex-direction: column;
      align-items: center;
    }
  </style>`;
};
